/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { TipoAccion, TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import IItemCompuesto from 'Infotrack@Modelos/smartStock/gestionProducto/entidades/itemCompuesto';
import { IImagen } from 'Infotrack@Transversales/componentes/inputImagen/interfaces';
import { AnyAction } from 'redux';
import { IInputsImagen, IInputsItem, IInputsItemPropiedades, IInputsItemUnidad } from './interfaces';

export interface IEstadoGestionProducto {
    estadoFormulario: boolean;
    estadoFormularioUnidades: boolean;
    estadoFormularioPropiedades: boolean;
    estadoFormularioImagenes: boolean;
    item: IInputsItem;
    itemUnidad: IInputsItemUnidad;
    itemPropiedad: IInputsItemPropiedades;
    itemImagen: IInputsImagen;
    idTipoUnidad?: number;
    tipoFormularioProducto: TipoFormulario;
    tipoFormularioUnidades: TipoFormulario;
    tipoFormularioPropiedades: TipoFormulario;
    tipoFormularioImagenes: TipoFormulario;
    recargarTabla: boolean;
    unidades: IInputsItemUnidad[];
    propiedades: IInputsItemPropiedades[];
    imagenes: IInputsImagen[];
    listaItem: IItemCompuesto[];
}

export const estadoInicial: IEstadoGestionProducto = {
    estadoFormulario: false,
    estadoFormularioUnidades: false,
    estadoFormularioPropiedades: false,
    estadoFormularioImagenes: false,
    item: {
        Abreviatura: '',
        Alto: 0,
        Ancho: 0,
        ClaseTecnicaId: '',
        ClasificacionId: '',
        CodigoBarras: '',
        Contenedor: false,
        DescripcionItem: '',
        EmpresaId: '',
        ManejaPeso: false,
        Estado: true,
        FabricanteId: '',
        FamiliaId: '',
        Importado: false,
        Largo: 0,
        Lotes: false,
        MarcaId: '',
        Modelo: '',
        Peso: 0,
        ReferenciaId: '',
        Seriado: false,
        Serialconsecutivo: false,
        UnidadId: '',
        FIFO: false,
        FEFO: false,
        RFId: '',
        Imagen: '',
        InventarioCritico:false,
        SinSaldo:false
    },
    itemUnidad: {
        Accion: TipoAccion.guardado,
        Alto: '',
        Ancho: '',
        EmpresaId: '',
        Estado: 1,
        IdTemporal: 1,
        Largo: '',
        Peso: '',
        Unidad: null,
    },
    itemPropiedad: {
        Accion: TipoAccion.guardado,
        ItemPropiedadId: '',
        TipoPropiedad: null,
        IdTemporal: 1,
        Estado: 1,
        ItemPropiedadTexto: '',
        ItemTipoPropiedadDescripcion: '',
        Cantidad: '',
    },
    itemImagen: {
        Accion: TipoAccion.guardado,
        DescripcionItemImagen: '',
        ImagenBase64: '',
        RutaImagen: '',
        IdTemporal: 1
    },
    idTipoUnidad: undefined,
    tipoFormularioProducto: TipoFormulario.Creacion,
    tipoFormularioUnidades: TipoFormulario.Creacion,
    tipoFormularioPropiedades: TipoFormulario.Creacion,
    tipoFormularioImagenes: TipoFormulario.Creacion,
    recargarTabla: false,
    unidades: [],
    propiedades: [],
    imagenes: [],
    listaItem: [],
};

export enum acciones {
    AGREGAR_ITEM_UNIDAD = 'AGREGAR_ITEM_UNIDAD',
    AGREGAR_ITEM_PROPIEDAD = 'AGREGAR_ITEM_PROPIEDAD',
    AGREGAR_ITEM_IMAGEN = 'AGREGAR_ITEM_IMAGEN',
    CARGAR_PROPIEDADES = 'CARGAR_PROPIEDADES',
    CARGAR_UNIDADES = 'CARGAR_UNIDADES',
    CARGAR_IMAGENES = 'CARGAR_IMAGENES',
    CAMBIAR_ESTADO_FORMULARIO = 'CAMBIAR_ESTADO_FORMULARIO',
    CAMBIAR_ESTADO_FORMULARIO_UNIDADES = 'CAMBIAR_ESTADO_FORMULARIO_UNIDADES',
    CAMBIAR_ESTADO_FORMULARIO_PROPIEDADES = 'CAMBIAR_ESTADO_FORMULARIO_PROPIEDADES',
    CAMBIAR_ESTADO_FORMULARIO_IMAGENES = 'CAMBIAR_ESTADO_FORMULARIO_IMAGENES',
    EDITAR_ITEM_PROPIEDADES = 'EDITAR_ITEM_PROPIEDADES',
    EDITAR_ITEM_UNIDAD = 'EDITAR_ITEM_UNIDAD',
    EDITAR_ITEM_IMAGEN = 'EDITAR_ITEM_IMAGEN',
    ELIMINAR_ITEM_UNIDAD = 'ELIMINAR_ITEM_UNIDAD',
    ELIMINAR_ITEM_PROPIEDADES = 'ELIMINAR_ITEM_PROPIEDADES',
    ELIMINAR_ITEM_IMAGENES = 'ELIMINAR_ITEM_IMAGENES',
    MODIFICAR_ITEM = 'MODIFICAR_ITEM',
    MODIFICAR_ITEM_UNIDAD = 'MODIFICAR_ITEM_UNIDAD',
    MODIFICAR_ITEM_PROPIEDADES = 'MODIFICAR_ITEM_PROPIEDADES',
    MODIFICAR_ITEM_IMAGENES = 'MODIFICAR_ITEM_IMAGENES',
    SELECCIONAR_TIPO_UNIDAD = 'SELECCIONAR_TIPO_UNIDAD',
    REINICIAR_CAMPOS_ITEM_PROPIEDADES = 'REINICIAR_CAMPOS_ITEM_PROPIDADES',
    RECARGAR_TABLA = 'RECARGAR_TABLA',
    AGREGAR_LISTA_ITEMS = 'AGREGAR_LISTA_ITEMS',
}

export const reductor = (estado: IEstadoGestionProducto = estadoInicial, { type, payload }: AnyAction) => {
    switch (type) {
        case acciones.AGREGAR_ITEM_UNIDAD: {
            const { unidades } = estado;
            const IdTemporal = unidades.length > 0 ? unidades[unidades.length - 1].IdTemporal + 1 : 1;
            return {
                ...estado,
                unidades: [...estado.unidades, { ...payload, Estado: payload.Estado ? 1 : 0, IdTemporal }],
            };
        }
        case acciones.AGREGAR_ITEM_PROPIEDAD: {
            return {
                ...estado,
                propiedades: [...estado.propiedades, { ...payload, Estado: payload.Estado ? 1 : 0 }],
                itemPropiedad: { ...estado.itemPropiedad, IdTemporal: estado.itemPropiedad.IdTemporal + 1 },
            };
        }

        case acciones.AGREGAR_LISTA_ITEMS: {
            return {
                ...estado,
                listaItem: payload,
            };
        }
        case acciones.AGREGAR_ITEM_IMAGEN: {
            return {
                ...estado,
                imagenes: [...estado.imagenes],
                itemImagen: { ...estado.itemImagen, IdTemporal: estado.itemImagen.IdTemporal + 1 },
            };
        }

        case acciones.CARGAR_UNIDADES: {
            const unidadesAEditar: IInputsItemUnidad[] = payload.map((unidad: IInputsItemUnidad, indice: number) => ({
                ...unidad,
                IdTemporal: indice + 1,
            }));

            const IdTemporal =
                unidadesAEditar.length > 0 ? unidadesAEditar[unidadesAEditar.length - 1].IdTemporal + 1 : 1;
            return {
                ...estado,
                unidades: unidadesAEditar,
                itemUnidad: { ...estado.itemUnidad, IdTemporal },
            };
        }

        case acciones.CARGAR_PROPIEDADES: {
            return {
                ...estado,
                propiedades: payload,
            };
        }

        case acciones.CARGAR_IMAGENES: {
            let listaImagenes: IInputsImagen[] = [];
            estado.imagenes.length === 0 ? listaImagenes = payload :
                payload.map((imgpayload: IInputsImagen) => {
                    let imagenFiltrada = estado.imagenes.find(img => img.DescripcionItemImagen === imgpayload.DescripcionItemImagen)
                    if (!imagenFiltrada) listaImagenes.push(imgpayload)

                    if (imagenFiltrada && imgpayload.Accion === TipoAccion.consulta) {
                        let indice = listaImagenes.findIndex(imgindice => imgindice.DescripcionItemImagen === imgpayload.DescripcionItemImagen)
                        listaImagenes.splice(indice);
                        listaImagenes.push({ ...imgpayload, ItemImagenId: imagenFiltrada!.ItemImagenId, Accion: imagenFiltrada!.ItemImagenId ? TipoAccion.editado : TipoAccion.guardado })
                    }
                });
            estado.imagenes.map(img => {
                if (!listaImagenes.find(imgfind => imgfind.DescripcionItemImagen === img.DescripcionItemImagen)) {
                    listaImagenes.push(img)
                }
            });
            return {
                ...estado,
                imagenes: listaImagenes,
            };
        };
        case acciones.CAMBIAR_ESTADO_FORMULARIO: {
            const { estadoFormulario } = estado;
            if (estadoFormulario) return estadoInicial;
            else
                return {
                    ...estado,
                    estadoFormulario: true,
                    tipoFormularioProducto: payload ? TipoFormulario.Edicion : estado.tipoFormularioProducto,
                    item: payload ? payload.Item : estado.item,
                    unidades: payload ? payload.Unidades : estado.unidades,
                    idTipoUnidad: payload ? payload.Item.TipoUnidadId : undefined,
                    propiedades: payload ? payload.Propiedades : estado.propiedades,
                    imagenes: payload && payload.Imagenes ? payload.Imagenes : estado.imagenes,
                };
        }

        case acciones.CAMBIAR_ESTADO_FORMULARIO_UNIDADES: {
            const { estadoFormularioUnidades } = estado;
            return {
                ...estado,
                estadoFormularioUnidades: !estado.estadoFormularioUnidades,
                itemUnidad: estadoFormularioUnidades ? estadoInicial.itemUnidad : payload ? payload : estado.itemUnidad,
                tipoFormularioUnidades: payload ? TipoFormulario.Edicion : TipoFormulario.Creacion,
            };
        }

        case acciones.CAMBIAR_ESTADO_FORMULARIO_PROPIEDADES: {
            const { estadoFormularioPropiedades } = estado;
            return {
                ...estado,
                estadoFormularioPropiedades: !estado.estadoFormularioPropiedades,
                itemPropiedad: estadoFormularioPropiedades
                    ? estadoInicial.itemPropiedad
                    : payload
                        ? payload
                        : estado.itemPropiedad,
                tipoFormularioPropiedades: payload ? TipoFormulario.Edicion : TipoFormulario.Creacion,
            };
        }

        case acciones.CAMBIAR_ESTADO_FORMULARIO_IMAGENES: {
            const { estadoFormularioImagenes } = estado;
            return {
                ...estado,
                estadoFormularioImagenes: !estado.estadoFormularioImagenes,
                itemImagen: estadoFormularioImagenes ? estadoInicial.itemImagen : payload ? payload : estado.itemImagen,
                tipoFormularioImagenes: payload ? TipoFormulario.Edicion : TipoFormulario.Creacion,
            };
        }
        case acciones.EDITAR_ITEM_UNIDAD: {
            const nuevasUnidades = [...estado.unidades];
            const indiceUnidad = nuevasUnidades.findIndex((unid) => unid.IdTemporal === payload.IdTemporal);
            const accionActual = nuevasUnidades[indiceUnidad].Accion;
            nuevasUnidades[indiceUnidad] = payload;
            nuevasUnidades[indiceUnidad].Accion =
                estado.tipoFormularioProducto === TipoFormulario.Edicion && accionActual !== TipoAccion.guardado
                    ? TipoAccion.editado
                    : TipoAccion.guardado;
            return {
                ...estado,
                unidades: nuevasUnidades,
            };
        }

        case acciones.EDITAR_ITEM_PROPIEDADES: {
            const nuevasPropiedades = [...estado.propiedades];
            const indicePropiedad = nuevasPropiedades.findIndex((prop) => prop.IdTemporal === payload.IdTemporal);
            const accionActual = nuevasPropiedades[indicePropiedad].Accion;
            nuevasPropiedades[indicePropiedad] = payload;
            nuevasPropiedades[indicePropiedad].Accion =
                estado.tipoFormularioProducto === TipoFormulario.Edicion && accionActual !== TipoAccion.guardado
                    ? TipoAccion.editado
                    : TipoAccion.guardado;
            return {
                ...estado,
                propiedades: nuevasPropiedades,
            };
        }

        case acciones.EDITAR_ITEM_IMAGEN: {
            const nuevasImagenes = [...estado.imagenes];
            const indiceImagen = nuevasImagenes.findIndex((prop) => prop.IdTemporal === payload.IdTemporal);
            const accionActual = nuevasImagenes[indiceImagen].Accion;
            nuevasImagenes[indiceImagen] = payload;
            nuevasImagenes[indiceImagen].Accion =
                estado.tipoFormularioImagenes === TipoFormulario.Edicion && accionActual !== TipoAccion.guardado
                    ? TipoAccion.editado
                    : TipoAccion.guardado;
            return {
                ...estado,
                imagenes: nuevasImagenes,
            };
        }
        case acciones.ELIMINAR_ITEM_UNIDAD: {
            const accionUnidad = estado.unidades.find(({ IdTemporal }) => IdTemporal === payload)!.Accion;
            return {
                ...estado,
                unidades:
                    estado.tipoFormularioProducto === TipoFormulario.Creacion || accionUnidad === TipoAccion.guardado
                        ? estado.unidades.filter(({ IdTemporal }) => IdTemporal !== payload)
                        : estado.unidades.map((unidad) => {
                            if (unidad.IdTemporal === payload) {
                                const nuevaUnidad = { ...unidad };
                                nuevaUnidad.Accion = TipoAccion.eliminado;
                                return nuevaUnidad;
                            }
                            return unidad;
                        }),
            };
        }
        case acciones.ELIMINAR_ITEM_PROPIEDADES: {
            const accionPropiedad = estado.propiedades.find(({ IdTemporal }) => IdTemporal === payload)!.Accion;
            return {
                ...estado,
                propiedades:
                    estado.tipoFormularioProducto === TipoFormulario.Creacion || accionPropiedad === TipoAccion.guardado
                        ? estado.propiedades.filter(({ IdTemporal }) => IdTemporal !== payload)
                        : estado.propiedades.map((propiedad) => {
                            if (propiedad.IdTemporal === payload) {
                                const nuevaPropiedad = { ...propiedad };
                                nuevaPropiedad.Accion = TipoAccion.eliminado;
                                return nuevaPropiedad;
                            }
                            return propiedad;
                        }),
            };
        }

        case acciones.ELIMINAR_ITEM_IMAGENES: {
            const imagenAEliminar = estado.imagenes.find(
                ({ DescripcionItemImagen }) => DescripcionItemImagen === payload
            );
            return {
                ...estado,
                imagenes:
                    imagenAEliminar && imagenAEliminar.ItemImagenId
                        ? estado.imagenes.map((imagen) => {
                            if (imagen.DescripcionItemImagen === imagenAEliminar.DescripcionItemImagen)
                                return { ...imagen, Accion: TipoAccion.eliminado };
                            return imagen;
                        })
                        : estado.imagenes.filter(({ DescripcionItemImagen }) => DescripcionItemImagen !== payload),
                /* estado.tipoFormularioProducto === TipoFormulario.Creacion || accionImagen === TipoAccion.guardado
            ? estado.imagenes.filter(({ IdTemporal }) => IdTemporal !== payload)
            : estado.imagenes.map((imagen) => {
                if (imagen.IdTemporal === payload) {
                  const nuevaImagen = { ...imagen };
                  nuevaImagen.Accion = TipoAccion.eliminado;
                  return nuevaImagen;
                }
                return imagen;
              }), */
            };
        }

        case acciones.SELECCIONAR_TIPO_UNIDAD: {
            return {
                ...estado,
                idTipoUnidad: payload,
            };
        }

        case acciones.MODIFICAR_ITEM: {
            const { llave, valor } = payload;
            return {
                ...estado,
                item: { ...estado.item, [llave]: valor },
            };
        }

        case acciones.MODIFICAR_ITEM_UNIDAD: {
            const { llave, valor } = payload;
            return {
                ...estado,
                itemUnidad: { ...estado.itemUnidad, [llave]: valor },
            };
        }

        case acciones.MODIFICAR_ITEM_PROPIEDADES: {
            const { llave, valor } = payload;
            return {
                ...estado,
                itemPropiedad: { ...estado.itemPropiedad, [llave]: valor },
            };
        }

        case acciones.MODIFICAR_ITEM_IMAGENES: {
            const { llave, valor } = payload;
            return {
                ...estado,
                itemImagen: { ...estado.itemImagen, [llave]: valor },
            };
        }

        case acciones.RECARGAR_TABLA: {
            return {
                ...estado,
                recargarTabla: !estado.recargarTabla,
            };
        }

        case acciones.REINICIAR_CAMPOS_ITEM_PROPIEDADES: {
            return {
                ...estado,
                itemPropiedad: { ...estadoInicial.itemPropiedad, TipoPropiedad: estado.itemPropiedad.TipoPropiedad },
            };
        }

        default:
            return estado;
    }
};
